import React, { FC } from 'react';
import Gallery from '@browniebroke/gatsby-image-gallery';
interface GalleryProps {
  images: any;
}

const ImageGallery: FC<GalleryProps> = ({ images }) => {
  const img = images.map(image => ({
    ...image.localFile.childImageSharp,
    thumbAlt: image.altText,
    title: image.title,
    caption: <div dangerouslySetInnerHTML={{ __html: image.description }} />,
  }));

  return <Gallery images={img} />;
};

export default ImageGallery;
